<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div class="notes-modal">
    <div class="m-container">
      <FormSheet>
        <h2>Poznámka</h2>
        <FormGroup
          label="Sem vpíšte poznámku"
        >
          <InputTextarea
            v-model="activity.agreement.description"
            :rows="7"
          />
        </FormGroup>
        <BaseButton
          @click="$emit('close')"
        >
          Uložiť
        </BaseButton>
      </FormSheet>
    </div>
  </div>
</template>

<script setup>
import FormSheet from '@/components/FormSheet.vue';
import FormGroup from '@/components/FormGroup.vue';
import InputTextarea from '@/components/InputTextarea.vue';
import BaseButton from '@/components/BaseButton.vue';

defineProps({
  activity: {
    type: Object,
    required: true,
  },
});

defineEmits(['close']);
</script>

<style scoped>
.notes-modal {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  top: 100px;
  z-index: 10;
  background-color: var(--white);
  box-shadow: var(--box-shadow-200);
  padding-top: 16px;
  border-top: var(--simple-border);
  border-radius: var(--border-radius) var(--border-radius) 0 0;
}
</style>
